/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-const */
import React, { useState, useEffect, useContext } from 'react';
import { axios } from '../services/ServiceUtils';
import { useLanguageContext } from './LanguageContext';

const HomeContext = React.createContext();

export const useHomeContext = () => useContext(HomeContext);

const { Provider, Consumer } = HomeContext;

const HomeProvider = props => {
  const [home, setHome] = useState({
    banner: {},
    modules: [],
    needHelp: { viewAllFaq: {}, findAnswers: {}, contactUs: {}, productSupport: {} },
    signIn: {
      emailAddress: '',
      submitButton: '',
      forgotPassword: '',
      newAccountHolder: '',
      createProfile: '',
    },
    birdSeedText: '',
    error: false,
    errorStatus: false,
  });

  const { language } = useLanguageContext();

  const { children } = props;

  const homeError = status => {
    setHome({
      banner: {},
      modules: [],
      needHelp: { viewAllFaq: {}, findAnswers: {}, contactUs: {}, productSupport: {} },
      signIn: {
        labelEmail: '',
        submitButton: '',
        forgotPassword: '',
        newAccountHolder: '',
        createProfile: '',
      },
      birdSeedText: '',
      error: true,
      errorStatus: status,
    });
  };
  useEffect(() => {
    axios
      .get('api/home', {
        headers: {
          'Content-Language': `${language.locale}`,
        },
      })
      .then(result => {
        if (!result.data?.dfsModules?.modules) {
          return null;
        }

        let modules = result.data.dfsModules.modules;

        modules.map(item => {
          const pillars = {
            'home-consumer': {
              order: 0,
              icon: '👩'
            },
            'home-small-business': {
              order: 1,
              icon: '🏢'
            },
            'home-enterprise': {
              order: 2,
              icon: '🏣'
            }
          };
          item.icon = pillars[item.key].icon;
          item.order = pillars[item.key].order;
          return item;
        });

        modules.sort((x, y) => x.order - y.order);

        const banner = {
          title: result.data?.title || '',
          description: result.data?.description || '',
          bannerUrl: result.data?.bannerUrl || '',
        }

        const needHelp = {
          title: result.data?.needHelp?.title || '',
          accountTypeHeading: result.data?.needHelp?.accountTypeHeading || '',
          categoryHeading: result.data?.needHelp?.categoryHeading || '',
          viewAllFaq: result.data?.needHelp?.viewAllFaq || '',
          findAnswers: result.data?.needHelp?.findAnswers || '',
          contactUs: result.data?.needHelp?.contactUs || '',
          productSupport: result.data?.needHelp?.productSupport || '',
        }

        setHome({
          banner,
          birdSeedText: result?.data?.birdSeedText || '',
          needHelp,
          signIn: {
            emailAddress: result.data?.signIn?.emailAddress || '',
            submitButton: result.data?.signIn?.submitButton || '',
            forgotPassword: result.data?.signIn?.forgotPassword || '',
            newAccountHolder: result.data?.signIn?.newAccountHolder || '',
            createProfile: result.data?.signIn?.createProfile || '',
          },
          modules,
          error: false,
          errorStatus: false,
        });
      })
      .catch(e => {
        homeError(e.response ? e.response.status : false);
        // eslint-disable-next-line
        console.error('request error at home', e.response ? e.response.status : e);
      });
  }, [language]);

  return <Provider value={home}>{children}</Provider>;
};

export { HomeProvider, Consumer as ConsumerProvider };
export default HomeContext;
